import { ApiProperty } from '@nestjs/swagger'

/**
 * Réponse contenant uniquement le schéma JSON et la configuration par défaut d'un type d'activité.
 * Utilisé pour la génération d'activités avec l'IA.
 */
export class ActivityTypeConfigResponseDto {
  @ApiProperty({
    type: Object,
    description: 'Schéma JSON définissant la structure du contenu',
  })
  jsonSchema!: Record<string, unknown>

  @ApiProperty({
    type: Object,
    description: 'Configuration par défaut pour la génération',
  })
  defaultConfig!: Record<string, unknown>
}
